var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEyeClosed = function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.662 5.955 5.707 4 4.293 5.414l1.694 1.694Q4.088 8.632 2.205 11.1a1 1 0 0 0 0 1.214c3.225 4.223 6.48 6.393 9.795 6.393 1.457 0 2.902-.419 4.338-1.247l1.955 1.954L19.707 18l-1.694-1.694q1.899-1.524 3.782-3.992a1 1 0 0 0 0-1.214C18.57 6.877 15.315 4.707 12 4.707c-1.457 0-2.902.42-4.338 1.248M7.41 8.532q-1.54 1.19-3.14 3.175c2.71 3.366 5.295 5 7.729 5q1.398.001 2.861-.724zm9.178 6.35-7.45-7.45q1.463-.726 2.861-.725c2.434 0 5.019 1.634 7.73 5q-1.6 1.986-3.14 3.175",
    clipRule: "evenodd"
  })));
};
export default SvgEyeClosed;